define('modules/Cart/CartManagerCustomizations',[
'jquery',
'global/all',
'plugins/jquery.proxyRequest'
], function ($, Roc) {
    'use strict';

    function bulkAddToCart(request) {
        return $.proxyRequest({
            type: 'POST',
            url: 'api/schematics/bulk/addtocartv2',
            data: JSON.stringify(request),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            serverCompleteAction: 'SetCurrentOrderId',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> bulkAdd2CartItems');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};
                Roc.EventManager.notify(Roc.Events.cart.ADD_ITEMS, response);
            }
        });
    }

    /**
     * Method to ensure compability with temp address id requirement (API side)
     * @returns {} 
     */
    function getTempAddressId() {
        return $('#hdnTempAddressId').val();
    }

    var CartManagerCustomizations = {
        bulkAddToCart: bulkAddToCart,
        getTempAddressId: getTempAddressId
    };

    Roc.Logger.debug('CartManagerCustomizations.js Loaded:', CartManagerCustomizations);

    return CartManagerCustomizations;
});
